import(/* webpackMode: "eager" */ "/vercel/path0/app/admin/layout.tsx");
